import { ReactElement } from "react";
import css from "~/pages/settings.module.scss";
import { format, fromUnixTime } from "date-fns";
import Link from "next/link";
import { Platform } from "~/types/platform";
import { Me } from "~/generated/rtk-query/nowdo-live-api.generated";

const SubscriptionPageLink = () => {
  return (
    <Link href="/subscriptions/new" className="_button primary round" data-test="subscribe-button">
      NowDoプレミアム登録する
    </Link>
  );
};

const UnSubscriptionPageLink = () => {
  return (
    <Link href="/cancel_subscription" className="_button primary outline round" data-test="unsubscribe-button">
      <u>解約する</u>
    </Link>
  );
};

const UnSubscriptionHelpLink = () => {
  return (
    <Link
      href="https://help.nowdo.in/nowdo/NowDo-4f80160b6c8e4cc48c1edfc7a754b544"
      className="_button primary outline round"
      data-test="unsubscribe-help-button"
    >
      <u>解約方法はこちら</u>
    </Link>
  );
};

type SubscriptionFieldProps = { me: Me };
export const SubscriptionField: React.FC<SubscriptionFieldProps> = ({ me }): ReactElement => {
  const birthday = format(fromUnixTime(me.birthDate), "yyyy年 生まれ");

  let expiredAtMessage: string | null = null;
  let unsubscriptionLink: JSX.Element | null = null;
  let unsubscriptionHelpLink: JSX.Element | null = null;
  if (me.subscriptionExpiresAt > 0) {
    expiredAtMessage = format(
      fromUnixTime(me.subscriptionExpiresAt),
      me.willUnsubscribed ? "yyyy年MM月dd日に自動解約されます。" : "yyyy年MM月dd日に自動更新されます。"
    );
    if (!me.willUnsubscribed) {
      if (me.subscribingPlatform === Platform.Web) {
        unsubscriptionLink = <UnSubscriptionPageLink />;
      }
      unsubscriptionHelpLink = <UnSubscriptionHelpLink />;
    }
  }

  return (
    <div className="field">
      <div className={css.profile}>
        <span className={css.image} />
        <p className={css.name}>{me.nickname}</p>
        <p>
          {me.isStudentAge ? "学生アカウント" : "ゲストアカウント"}（{birthday}）
        </p>
        <div data-test="subscribe-status-text">
          {(() => {
            // 提携学校学生は Now Do Premium 対象外なのでなし
            if (me.isPartnerSchoolStudent) {
              return;
            }
            if (!me.isSubscribed) {
              return <SubscriptionPageLink />;
            }
            return (
              <>
                <p>
                  {me.willUnsubscribed
                    ? "NowDo Premium 会員停止済み（解約日まで利用できます）"
                    : "NowDo Premium 会員登録済み"}
                </p>
                <p className="sub">{expiredAtMessage}</p>
                <p className={css.unsubscription_buttons}>
                  {unsubscriptionLink}
                  {unsubscriptionHelpLink}
                </p>
              </>
            );
          })()}
        </div>
      </div>
    </div>
  );
};
